export const TV_VIDEO_MARKER = '[tellustv:video]'
export const TV_SEGMENT_MARKER = '[tellustv:segment]'
export const TV_MASTER_PREFIX = 'MASTER:'
export const TV_SEGMENT_DURATION_PREFIX = 'DURMS:'
export const TV_TOTAL_DURATION_PREFIX = 'TOTALMS:'

export type TVSegment = {
  uri: string
  durationMs: number
  cid?: string
  mimeType?: string
  byteLength?: number
  order?: number
  jobId?: string
}

export type TVMasterRecord = {
  $type: 'app.tellus.video.master'
  title: string
  description?: string
  createdAt: string
  segments: TVSegment[]
  totalDurationMs: number
  segmentSeconds?: number
  thumbnailCid?: string
  thumbnailMime?: string
  thumbnailAspect?: '16:9'
}
